import { useId } from 'react';
import styled from 'styled-components';

// Soft brand glow behind the illustration; the token flips (neon indigo on dark,
// soft cobalt shadow on light) so the art reads on either surface.
const Wrap = styled.div`
  display: inline-flex;
  filter: drop-shadow(${props => props.theme.brand.glowIndigo});
`;

type Props = { size?: number; className?: string };

/** Rebrand-aligned empty-state illustration for error / something-went-wrong contexts —
 *  a brand-gradient alert triangle (cyan→cobalt→indigo) with rounded tips + sparkles
 *  (kit `empty-error.svg`). The vivid gradient + glow are mode-agnostic. */
const EmptyError = ({ size = 104, className }: Props) => {
  const gid = `error-${useId().replace(/:/g, '')}`;
  return (
    <Wrap className={className}>
      <svg width={size} height={Math.round(size * 0.8)} viewBox='0 0 120 96' fill='none' aria-hidden='true'>
        <defs>
          <linearGradient id={gid} x1='18' y1='84' x2='102' y2='14' gradientUnits='userSpaceOnUse'>
            <stop offset='0' stopColor='#7DE5F3' />
            <stop offset='0.5' stopColor='#4664F9' />
            <stop offset='1' stopColor='#8D85FB' />
          </linearGradient>
        </defs>
        <ellipse cx='60' cy='88' rx='36' ry='5' fill={`url(#${gid})`} opacity='0.14' />
        <path
          d='M60,20 L94,76 L26,76 Z'
          fill={`url(#${gid})`}
          fillOpacity='0.10'
          stroke={`url(#${gid})`}
          strokeWidth='5'
          strokeLinejoin='round'
        />
        <path d='M60,42 L60,58' stroke={`url(#${gid})`} strokeWidth='5.5' strokeLinecap='round' />
        <circle cx='60' cy='67' r='3.2' fill={`url(#${gid})`} />
        <path d='M100,22 Q100,27 105,27 Q100,27 100,32 Q100,27 95,27 Q100,27 100,22 Z' fill='#7DE5F3' />
        <circle cx='18' cy='30' r='3' fill='#7DE5F3' opacity='0.75' />
        <circle cx='103' cy='58' r='2.2' fill='#4664F9' opacity='0.6' />
      </svg>
    </Wrap>
  );
};

export default EmptyError;
